import * as PnrHistory from './components/PnrHistory.css';

export default {
	PnrHistory
};
